import React from 'react';
import Home from './Home.jsx';


const App =()=>{
	return(
		<>
			<Home/>
		</>
	);
}

export default App;